import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarousel = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0.51 0 22.89 22.89",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.511719 2.82476C0.511719 1.26469 1.77641 0 3.33648 0H15.8689C17.4289 0 18.6936 1.26469 18.6936 2.82476V15.3571C18.6936 16.9172 17.4289 18.1819 15.8689 18.1819H3.33648C1.77641 18.1819 0.511719 16.9172 0.511719 15.3571V2.82476Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.71826 20.4251C3.89552 21.8147 5.0824 22.8889 6.52017 22.8889H20.5785C22.1386 22.8889 23.4033 21.6242 23.4033 20.0641V6.00577C23.4033 4.56733 22.3281 3.38 20.9376 3.20361V17.6004C20.9376 19.1604 19.6729 20.4251 18.1128 20.4251H3.71826Z",
		fill: "white"
	})]
});
export default SvgCarousel;
